import { type Component, createVNode, render } from 'vue'
import { type ComponentProps } from 'vue-component-type-helpers'

import { config } from './config.ts'

interface MountOptions<TProps> {
  props?: TProps
  container?: HTMLElement
  name?: string
}

export function mount<T extends Component>(component: T, { props, container, name }: MountOptions<ComponentProps<T>> = {}) {
  const vNode = createVNode({ ...component, name: name ? name : component.name }, props)

  const el = document.createElement('div')
  container ??= document.body
  container.appendChild(el)

  vNode.appContext = config.app?._context ?? null
  render(vNode, el)

  return { vNode, el }
}
